import { lazy } from 'react'
import { redirect } from 'react-router-dom'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const ScheduleRootPage = lazy(() => import('modules/project_management/pages/ScheduleRootPage'))
const ScheduleContributorsPage = lazy(
  () => import('modules/project_management/pages/ScheduleContributorsPage')
)

export const scheduleRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.projects.schedule.path,
      element: <ScheduleRootPage />,
      handle: {
        meta: () => ({
          title: i18n.t('project_management.meta_data.schedule.title'),
          description: i18n.t('project_management.meta_data.schedule.description'),
          illustration: 'calendar',
        }),
      },
      children: [
        {
          index: true,
          loader: () => redirect(navigation.projects.schedule.contributors.path),
        },
        {
          path: navigation.projects.schedule.contributors.path,
          element: <ScheduleContributorsPage />,
        },
      ],
    },
  ]
}
